<template>
  <v-container
    id="classView"
  >
    <v-overlay class="waitoverlay" :value="busy">
     <v-progress-circular
      indeterminate
      size="64"
      class="mr-4"
    /> {{ $t('global.loading') }}
    </v-overlay>
    <v-breadcrumbs :items="breadcrumbs" divider="-" />
    <v-row justify="center">
      <v-dialog v-model="showGenerator" max-width="500px">
        <shortcode-generator ref="generator" action="classShortCode" :class-id="currentClassID" :title="$t('class.class-code')">
          <p>{{ $t('class.class-code-description') }}</p>
          <p><b>{{ $t('class.class-code-warning') }}</b></p>
        </shortcode-generator>
      </v-dialog>
    </v-row>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="6">
            {{ className }}
          </v-col>
          <v-col cols="6" class="text-end">
            <v-btn v-if="currentClass" color="blue" @click="showShortcodeGenerator">
            {{ $t('class.show-class-code') }}
            </v-btn>
            <v-btn v-if="currentClass" color="primary" @click="showUserSelectDialog">
              {{ $t('class.add-learners') }}
            </v-btn>
            <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="secondary"
              dark
              width="1px"
              v-bind="attrs"
              v-on="on"
            >
            <v-icon class="">
              mdi-menu
            </v-icon>
            </v-btn>
          </template>
          <v-list width="260px" class="pa-0">
            <v-list-item class="pa-0">
              <v-btn :text="true" color="black" block @click="viewStats">
                {{ $t('class.view-stats') }}
              </v-btn>
            </v-list-item>
            <v-list-item class="pa-0">
              <v-btn :text="true" color="black" block @click="editClass">
                {{ $t('class.edit') }}
              </v-btn>
            </v-list-item>
            <v-list-item v-if="currentClass && (currentClass.enrolmentType !== undefined && currentClass.enrolmentType !== 'inviteOnly')" class="pa-0">
              <v-btn
                v-if="currentClass && (currentClass.enrolmentType !== undefined && currentClass.enrolmentType !== 'inviteOnly')"
                :text="true"
                color="black"
                block
                @click="enrolmentLinkVisible=true"
              >
                {{ $t('class.enrolment-link') }}
              </v-btn>
            </v-list-item>
            <v-list-item class="pa-0">
              <v-btn :text="true" color="black" block @click="confirmInviteAll">
                {{ $t('class.send-invitations') }}
              </v-btn>
            </v-list-item>
            <v-list-item v-if="hasDataSharingPermission" class="pa-0">
              <v-btn :text="true" color="black" block @click="viewSettings">
                {{ $t('data-settings') }}
              </v-btn>
            </v-list-item>
            <v-list-item v-if="hasDataSharingPermission" class="pa-0">
              <v-btn :text="true" color="black" block @click="viewExport">
                {{ $t('export-data') }}
              </v-btn>
            </v-list-item>
            <v-list-item class="pa-0">
              <v-btn :text="true" color="black" block @click="exportData">
                {{ $t('download-class') }}
              </v-btn>
            </v-list-item>
            <v-list-item class="pa-0">
              <v-btn :text="true" color="black" block @click="refreshItems">
                {{ $t('class.refresh') }}
              </v-btn>
            </v-list-item>
          </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
        <div class="searchBox">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('global.search')"
            single-line
            hide-details
            class="limitWidth"
          />
        </div>
        <v-data-table
          v-model="selected"
          filterable
          :headers="headers.map((x) => { return { ...x, text: $t(x.text) } })"
          :items="items"
          item-key="id"
          :loading="loading"
          :search="search"
          :items-per-page="30"
          :footer-props="{'items-per-page-options':[15, 30, 50, 100, -1]}"
        >
        <template v-slot:item.code="{ item }">
          <div v-if="item.code">
            {{ item.code }}
          </div>
          <div v-else>
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon v-on="on" @click="shortCode(item)">
                mdi-key-outline
              </v-icon>
            </template>
            <span>{{ $t('get-quick-code') }}</span>
          </v-tooltip>
        </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon class="mr-2" :disabled="loading" v-on="on" @click="deleteItem(item)">
                mdi-delete-outline
              </v-icon>
            </template>
            <span>{{ $t('delete') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template #activator="{ on }">
               <v-icon class="mr-2" v-on="on" @click="sendInvite(item)">
                mdi-email-outline
              </v-icon>
            </template>
            <span>{{ $t('send-invitations') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.displayName="{ item }">
          <a :href="createURL(item)">
            {{ getClassLearnerName(item) }}
          </a>
        </template>
        <template v-slot:item.email="{ item }">
            {{ item.email }}
        </template>
        <template v-slot:item.tag="{ item }">
            {{ item.tag }}
        </template>
        <template v-slot:item.statusText="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-chip class="status-chip" :class="item.status" v-on="on">
                <div style="width:150px; height: 100%">
                  <v-progress-linear
                    :value="item.progress"
                    height="100%"
                    color="green"
                    class="status-progress-bar"
                    :class="item.status+'-bar'"
                    background-color="transparent"
                  />
                </div>
                <div class="status-text">
                  {{ item.statusText }}
                </div>
              </v-chip>
            </template>
            <div v-html="item.tooltip" />
          </v-tooltip>
        </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-row justify="center">
      <v-dialog v-model="userSelectDialogVisible" max-width="700px">
        <user-selection-dialog
          ref="selectionDialog"
          :items="addLearnersList"
          @cancel="cancelUserSelectDialog"
          @save="saveUserSelectDialog"
        />
      </v-dialog>
      <v-dialog v-model="dataSettingsWindow" max-width="500px">
        <v-card>
          <v-card-title>{{ $t('data-settings-0') }}</v-card-title>
          <v-card-text>
          <v-form
          ref="form"
        >
          <v-switch
            v-model="dataSharing.enableDataSharing"
            :label="$t('enable-data-sharing')"
            inset
          />
          <v-expand-transition>
           <div v-show="dataSharing.enableDataSharing">
            <v-select
                v-model="dataSharing.agreementID"
                :label=" $t('agreement-id') "
                :hint="$t('this-is-a-unique-that-is-provided-to-you-by-bodyswaps')"
                :items="agreementKeys"
                persistent-hint
              />
              <v-switch
                v-model="dataSharing.mandatory"
                :label="$t('mandatory')"
                inset
              />
              <v-expand-transition>
                <v-card v-show="dataSharing.agreementID">
                  <v-card-text>
                    <p>{{ $t('class.settings') }}</p>
                    <v-textarea
                    v-model="agreementText"
                    :label="$t('in-app-agreement-text')"
                    readonly
                    :required="false"
                    persistent-hint
                    />
                    <v-text-field
                      v-model="agreementUrl"
                      :rules="rules.isUrl"
                      :label="url"
                      readonly
                      :required="false"
                      persistent-hint
                    />
                    <v-switch
                      v-model="agreementAnonymise"
                      :label="$t('anonymise-data-0')"
                      inset
                      readonly
                    />
                  </v-card-text>
                </v-card>
              </v-expand-transition>
            </div>
          </v-expand-transition>
           <v-card-actions>
          <v-btn color="secondary" @click="closeSettingsDialog">
{{ $t('global.cancel') }}
</v-btn>
            <v-spacer />
            <v-btn color="blue" @click="saveSettings">
{{ $t('save') }}
</v-btn>
            </v-card-actions>
        </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showViewExport" max-width="500px">
            <v-card>
          <v-card-title>{{ $t('export-data-0') }}</v-card-title>
          <v-card-text>
            <date-range-picker text-color="blacktext" @datesChange="exportDataDatesChanged" />
           <v-card-actions>
          <v-btn color="secondary" @click="cancelExportClassData">
{{ $t('global.cancel') }}
</v-btn>
            <v-spacer />
            <v-btn color="blue" @click="exportClassData">
{{ $t('save') }}
</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showDeleteDialog" max-width="700px">
        <v-card>
          <v-card-title>{{ $t('class.remove-dialog.title', [editedItem.displayName]) }}</v-card-title>
          <v-card-text>{{ $t('class.remove.confirmtext', [editedItem.displayName]) }}</v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="secondary" @click="closeDeleteDialog">
{{ $t('global.cancel') }}
</v-btn>
            <v-btn color="error" @click="confirmDeleteItem">
OK
</v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="inviteAllDialogVisible" max-width="700px">
        <v-card>
          <v-card-title>{{ $t('class.send-invitations') }}</v-card-title>
          <v-card-text><p v-html="$t('class.send-invite-text')" /></v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="secondary" @click="cancelInviteAll">
{{ $t('global.cancel') }}
</v-btn>
            <v-btn color="primary" @click="inviteNew">
{{ $t('class.uninvited') }}
</v-btn>
            <v-btn color="error" @click="inviteAll">
{{ $t('class.everyone') }}
</v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="enrolmentLinkVisible" max-width="700px">
        <v-card>
          <v-card-title>{{ $t('class.enrolment-link') }}</v-card-title>
          <v-card-text>
            <p>{{ $t('class.enrolment-link-instructions') }}</p>
            <v-spacer>
              <link-sharer
                :link="enrolmentLink"
              />
            </v-spacer>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="enrolmentLinkVisible = false">
{{ $t('global.close') }}
</v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
    >
      {{ inviteText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('global.close') }}
</v-btn>
      </template>
    </v-snackbar>

    <v-row justify="center">
      <v-dialog
        v-model="showClassEditDialog"
        max-width="700px"
      >
        <class-edit
          :model="currentClass"
          :editors="coaches"
          @cancel="closeClassEditDialog"
          @save="saveClass"
        />
      </v-dialog>
    </v-row>
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </v-container>
</template>

<script>

  import api from '@/helpers/api.js'
  import firebase from 'firebase/app'
  import 'firebase/auth'
  import { Roles, Users } from '@/helpers/users.js'
  import userSelectDialog from './UsersSelectDialog'
  import linkSharer from './LinkSharer'
  import DateRangePicker from './DateRangePicker'
  import { ContentLibrary } from '@/helpers/contentLibrary.js'
  import classCreate from './ClassEditDialog.vue'
  import sessionsAPI from '@/helpers/sessions.js'
  import { getRegionParam } from '@/helpers/shared'
  import shortcodeGenerator from './ShortcodeGenerator.vue'

  export default {
    name: 'Class',

    components: {
      'user-selection-dialog': userSelectDialog,
      'link-sharer': linkSharer,
      'date-range-picker': DateRangePicker,
      'class-edit': classCreate,
      'shortcode-generator': shortcodeGenerator,
    },

    data () {
      return {
        showClassEditDialog: false,
        loading: false,
        snackbar: false,
        timeout: 3000,
        scope: 'Class',
        classId: this.$route.params.id,
        platformUsageIndex: 0,
        totalSessions: 0,
        activeUniqueUsers: 0,
        trainingMinutes: 0,
        newUserCount: 0,
        showViewExport: false,
        agreementID: null,
        dataSharing: {
          enableDataSharing: false,
          agreementID: '',
          mandatory: true,
        },
        agreements: [],
        url: 'URL',
        format: 'csv',
        inviteText: '',
        userSelectDialogVisible: false,
        showEditDialog: false,
        showDeleteDialog: false,
        dataSettingsWindow: false,
        anonymiseData: !this.$store.getters.userHasRole(Roles.SYSADMIN),
        editedIndex: -1,
        inviteAllDialogVisible: false,
        enrolmentLinkVisible: false,
        editedItem: {},
        coaches: [],
        content: [],
        currentClass: undefined,
        users: [], // after the dialog closes this contains the users to add to the main list
        search: '',
        selected: [],
        items: [],
        addLearnersList: [],
        headers: [
          { text: 'class.header.learner', value: 'displayName', align: 'start', sortable: true },
          { text: 'class.header.email', value: 'email', sortable: true },
          { text: 'class.header.tag', value: 'tag', sortable: true },
          { text: 'class.header.status', sortable: true, value: 'statusText' },
          { text: 'class.header.code', value: 'code', sortable: true },
          { text: 'class.header.actions', value: 'actions', sortable: false },
        ],
        busy: false,
        rules: {
          isUrl: [(value) => (!value || /^(?:\w+:)?\/\/([^\s.]+\.\S{2}|localhost[:?\d]*)\S*$/.test(value)) || 'Invalid URL'],
        },
        showGenerator: false,
      }
    },

    computed: {
      agreementText () {
        return this.agreements?.find(x => x.key === this.dataSharing.agreementID)?.agreementText
      },
      agreementUrl () {
        return this.agreements?.find(x => x.key === this.dataSharing.agreementID)?.agreementUrl
      },
      agreementAnonymise () {
        return this.agreements?.find(x => x.key === this.dataSharing.agreementID)?.anonymiseData
      },
      agreementKeys () {
        return this.agreements.map(x => x.key)
      },
      hasDataSharingPermission () {
        // check if creator of the class
        if (!this.currentClass) {
          return false
        }
        const ownerAndRichDataExportEnabled = (this.currentClass.creator.id === this.$store.getters.currentUserProfile.user.id) && (this.$store.getters.currentUserProfile.account?.permissions?.allowRawDataExport)
        return ownerAndRichDataExportEnabled
      },
      className () {
        return this.currentClass ? this.currentClass.name : this.$t('global.loading')
      },
      totalClassSessions () {
        return this.$store.getters.totalClassSessions
      },
      activeClassUsers () {
        return this.$store.getters.activeClassUsers
      },
      classTrainingMinutes () {
        return this.$store.getters.classTrainingMinutes
      },
      newClassUsers () {
        return this.$store.getters.newClassUsers
      },
      account () {
        if (this.$route.query.account) {
          return this.$route.query.account
        } else {
          return this.$store.getters.currentUserProfile.user.account
        }
      },
      breadcrumbs () {
        return [
          {
            text: this.$t('class.classes'),
            disabled: false,
            href: '#/admin/classes/',
          },
          {
            text: this.className,
            disabled: true,
            href: '#/admin/classes/' + this.$route.params.id,
          },
        ]
      },
      enrolmentLink () {
        const locale = this.$store.getters.currentUserProfile.account.locale ?? 'en'
        const regionParam = getRegionParam('&')
        console.log(regionParam)
        return this.currentClass ? `${process.env.VUE_APP_URL}/#/enrol?enrolmentKey=${this.currentClass.enrolmentKey}&locale=${locale}${regionParam}` : ''
      },
      superUser () {
        return this.$store.getters.currentUserProfile.user.roles.includes(Roles.SUPER)
      },
      currentClassID () {
        return this.currentClass && this.currentClass.id ? this.currentClass.id : null
      },
    },

    async mounted () {
      this.loading = true
      const promises = [
        this.refreshItems(),
        api.getAgreements(),
        Users.Get(['coach']),
      ]
      const [, agreements, coaches] = await Promise.all(promises)
      this.agreements = agreements
      this.coaches = coaches
      this.loading = false
    },

    methods: {
      editClass () {
        // console.log('editing CurrentClass = ' + JSON.stringify(this.currentClass))
        this.showClassEditDialog = true
      },
      closeClassEditDialog () {
        this.showClassEditDialog = false
      },
      async saveClass (modifiedClass) {
        this.currentClass = modifiedClass
        await api.updateClass(this.$route.params.id, modifiedClass)
        this.classContentMap = this.expandContent(this.currentClass.content)
        this.updateViewList()
        this.showClassEditDialog = false
      },
      viewStats () {
        this.$router.push({
          name: 'classStats',
          query: { className: this.className },
        })
        // this.$router.push({ path: `/admin/classes/${this.$route.params.id}}/stats?className=${this.className}` })
      },
      async shortCode (item) {
        item.code = '------'
        this.items.splice(this.items.indexOf(item), 1, item)
        const payload = await api.getJoinClassShortCodeNoInvite(item.id)
        item.code = payload.shortCode
        this.items.splice(this.items.indexOf(item), 1, item)
      },
      exportData () {
        const modules = []
        this.currentClass.classLearners.forEach((classLearner) => {
          if (classLearner.progress) {
            // add all unique keys to modules
            Object.keys(classLearner.progress).forEach((module) => {
              if (!modules.includes(module)) {
                modules.push(module)
              }
            })
          }
        })

        const moduleNames = []
        // get the localised name of each module
        modules.forEach((module, i) => {
          moduleNames[i] = ContentLibrary.NameOf(this.$store, this.$i18n.locale, module)
        })
        let csv = 'Name,Email,Access Code,' + moduleNames.join(',') + '\n'
        this.currentClass.classLearners.forEach((row, i) => {
          csv += [row.displayName, row.email, this.items[i].code].join(',')
          modules.forEach((module) => {
            if (row.progress && row.progress[module]) {
              // display the sum of the values in row.progress[module]
              csv += ',' + Object.keys(row.progress[module]).reduce((accumulator, checkpointId) => {
                return ContentLibrary.GetCheckpointValue(this.$store, module, checkpointId) + accumulator
              }, 0) + '%'
            } else {
              csv += ','
            }
          })
          csv += '\n'
        })
        const anchor = document.createElement('a')
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
        anchor.target = '_blank'
        anchor.download = this.currentClass.name + ' Export.csv'
        anchor.click()
        // console.log(csv)
      },
      getClassLearnerName (item) {
        return item.displayName
      },
      async viewSettings () {
        this.loading = true
        await this.refreshItems()
        this.loading = false
        this.dataSettingsWindow = true
      },
      async exportClassData () {
        try {
          this.busy = true
          this.showViewExport = false
          // console.log({ op: this.anonymiseData })
          const eventsData = await api.getEventCollections(this.exportStartDate, this.exportEndDate, this.scope, this.classId, this.format, this.anonymiseData)
          const anchor = document.createElement('a')
          anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(eventsData)
          anchor.target = '_blank'
          anchor.download = this.currentClass.name + 'Events Export.csv'
          anchor.click()
          this.busy = false
        } catch (err) {
          console.log('Extraction Failed: ' + err.message + ' ' + err.stack)
        }
      },
      cancelExportClassData () {
        this.showViewExport = false
      },
      datesChanged (dates) {
        this.startDate = dates[0]
        this.endDate = dates[1]
      },
      exportDataDatesChanged (date) {
        this.exportStartDate = date[0]
        this.exportEndDate = date[1]
      },
      getStatus (item) {
        return this.getClassLearnerStatus(item)
      },
      calcModuleCompletions (progress) {
        const modulePercentages = Object.keys(this.classContentMap).reduce((acc, moduleId) => {
          const moduleMeta = ContentLibrary.GetModuleInfo(this.$store, moduleId)
          const moduleTotal = sessionsAPI.calculateProgressFromClassLearner(moduleMeta, progress)
          acc[moduleId] = moduleTotal
          return acc
        }, {})
        return modulePercentages
      },
      totalCompletionPercentageForClass (progress) {
        if (!this.classContentMap) {
          return 0
        }

        let max = 0 // total percentage points the whole class is worth
        let total = 0 // what the user has done from this

        const moduleProgressDictionary = this.calcModuleCompletions(progress)

        // Go through all the content assigned to this class module by module
        Object.keys(this.classContentMap).forEach((moduleId) => {
          const moduleMeta = ContentLibrary.GetModuleInfo(this.$store, moduleId)
          // --- Usually in the database we have stored what each checkpoint is worth in terms of percentage
          if (moduleMeta) {
            const moduleTotal = moduleProgressDictionary[moduleMeta.id]

            // if there are no checkpoints in the map for this module, assume we are meant to complete it all otherwise sum the checkpoint values in the DB
            max += this.classContentMap[moduleId].length === 0 ? 100
              : this.classContentMap[moduleId].reduce((accumulator, currentValue) => {
                // console.log(currentValue)
                return accumulator + ContentLibrary.GetCheckpointValue(this.$store, moduleId, currentValue)
              }, 0)
            total += moduleTotal
            // console.log('Checkpoint Calculation: module = ' + moduleId + ' moduleTotal = ' + moduleTotal + ': moduleDuration = ' + ContentLibrary.GetDuration(this.$store, moduleId))
          }
          // ---- However if don't have this information we can still make an estimate based on completion data and duration
          else {
            let moduleTotal = 0
            if (progress[moduleId] !== undefined) {
              moduleTotal = (Object.values(progress[moduleId]).reduce((accumulator, currentValue) => {
                return currentValue > accumulator ? currentValue : accumulator
              }, 0))
            }
            total += moduleTotal // (moduleTotal / 100) * moduleDuration
            max += 100
          }
        })
        // console.log(total + ' out of ' + max + ' = ' + Math.round((total / max) * 100) + '%')
        return Math.round((total / max) * 100)
      },

      progressPerModuleText (progress) {
        let output = ''
        const moduleProgressDictionary = this.calcModuleCompletions(progress)

        // go through the dictionary and output the name of the module and completion for each, otherwise output 0%
        Object.keys(this.classContentMap).forEach((moduleId) => {
          if (moduleProgressDictionary[moduleId] !== undefined) {
            output += ContentLibrary.NameOf(this.$store, this.$i18n.locale, moduleId) + ' (' + moduleProgressDictionary[moduleId] + '%)<br>'
          } else {
            output += ContentLibrary.NameOf(this.$store, this.$i18n.locale, moduleId) + ' (0%)<br>'
          }
        })
        return output
      },

      getClassLearnerStatus (item) {
        // console.log('item = ' + JSON.stringify(item))
        if (item.progress) {
          const completionPercentage = this.totalCompletionPercentageForClass(item.progress)
          const progressFormatted = this.progressPerModuleText(item.progress)
          if (completionPercentage < 100) {
            return { type: 'inprogress', text: this.$t('class.status.completionPercent', { value: completionPercentage }), progress: completionPercentage, tooltip: progressFormatted }
          } else {
            return { type: 'completed', text: this.$t('class.status.lesson-complete') }
          }
        }
        if (item.completedSession !== undefined) {
          return { type: 'submitted', text: item.completedSession.length + ' ' + this.$t('class.status.module-complete') }
        }
        if (item.inviteUses !== undefined && item.inviteUses > 0) {
          return { type: 'activated', text: this.$t('class.status.started') }
        }
        if (item.inviteUses !== undefined && item.inviteUses === 0) {
          return { type: 'invited', text: (item.invitesSent === undefined ? '1' : item.invitesSent) + ' ' + this.$t('class.status.invite-sent') }
        }
        return { type: 'none', text: this.$t('class.status.requires-invite') }
      },
      confirmInviteAll () {
        this.inviteAllDialogVisible = true
      },
      cancelInviteAll () {
        this.inviteAllDialogVisible = false
      },
      async inviteAll () {
        this.inviteAllDialogVisible = false
        this.busy = true
        const returnURL = `${process.env.VUE_APP_URL}/#/launch`
        await api.classInviteAll(this.$route.params.id, false, returnURL)
        this.busy = false
        await this.refreshItems()
      },
      async inviteNew () {
        this.inviteAllDialogVisible = false
        this.busy = true
        const returnURL = process.env.VUE_APP_URL + '/#/launch'
        await api.classInviteAll(this.$route.params.id, true, returnURL)
        this.busy = false
        await this.refreshItems()
      },
      createURL (item) {
        return `#/admin/classes/${this.$route.params.id}/learner/${item.id}`
      },
      isOwner: function (item) {
        return item.creator.id === undefined || item.creator.id === firebase.auth().currentUser.uid
      },
      contentDisplayName (contentID) {
        return this.$t('modules.' + contentID)
      },
      expandContent (content) {
        // Given a string of module1{checkpoint1,checkpoint2),module2,module3(checkpoint1) convert into a map with modules as keys and checkpoints as an array
        const contentmap = {}
        if (content) {
          content.forEach((module) => {
            const moduleParts = module.split('(')
            const moduleName = moduleParts[0]
            const checkpoints = moduleParts[1] ? moduleParts[1].split(',') : []
            if (checkpoints.length > 0) {
              checkpoints[checkpoints.length - 1] = checkpoints[checkpoints.length - 1].replace(/\)/, '')
            }
            contentmap[moduleName] = checkpoints
          })
        }
        // console.log(JSON.stringify(contentmap))
        return contentmap
      },
      updateViewList () {
        this.classContentMap = this.expandContent(this.currentClass.content)
        if (this.currentClass.dataSharing) {
          this.dataSharing = this.currentClass.dataSharing
        }
        this.items = []
        if (this.currentClass.classLearners.length > 0) {
          this.currentClass.classLearners.forEach((classLearner) => {
            const status = this.getClassLearnerStatus(classLearner)
            this.items.push({
              id: classLearner.id,
              displayName: classLearner.displayName,
              email: classLearner.email,
              tag: classLearner.tag,
              code: classLearner.code,
              status: status.type,
              statusText: status.text,
              progress: status.progress,
              tooltip: status.tooltip,
            })
          })
        }
      },
      async refreshItems () {
        this.loading = true
        this.currentClass = await api.getClass(this.$route.params.id)
        // console.dir(this.currentClass)
        this.currentClass.id = this.$route.params.id
        await ContentLibrary.Get(this.$store, this.$i18n)
        this.updateViewList()
        this.loading = false
      },
      // DELETE CLASS LEARNER METHODS
      async confirmDeleteItem () {
        this.showDeleteDialog = false
        this.busy = true
        await api.deleteClassLearner(this.editedItem.id)
        this.items.splice(this.editedIndex, 1)
        this.busy = false
      },
      deleteItem (item) {
        this.editedItem = item
        this.editedIndex = this.items.indexOf(item)
        this.showDeleteDialog = true
      },
      closeDeleteDialog () {
        this.showDeleteDialog = false
      },
      async saveSettings () {
        this.busy = true
        this.dataSettingsWindow = false
        await api.updateClass(this.$route.params.id, { dataSharing: this.dataSharing })
        this.currentClass = await api.getClass(this.$route.params.id)
        // Should trigger a refresh of the items
        this.busy = false
      },
      viewExport () {
        this.showViewExport = true
      },
      closeSettingsDialog () {
        this.dataSettingsWindow = false
      },
      async sendInvite (item) {
        this.busy = true
        const returnURL = process.env.VUE_APP_URL + '/#/launch'
        await api.sendClassLearnerInvite(item.id, returnURL)
        this.busy = false
        if (item.inviteUses !== undefined) {
          this.inviteText = this.$t('class.invite-resent')
        } else {
          item.inviteUses = 0
          this.inviteText = this.$t('class.invite-sent')
        }
        this.snackbar = true
      },
      showEnrolmentLink () {
        this.enrolmentLinkVisible = true
      },
      // ADD LEARNERS METHODS
      async showUserSelectDialog () {
        // get list of users
        this.userSelectDialogVisible = true
        this.busy = true
        var allusers = await Users.Get(['learner'])
        var ignoreIDs = this.items.map(x => x.user)
        allusers = allusers.filter(x => { return !ignoreIDs.includes(x.id) && x.email })
        this.addLearnersList = allusers === null ? [] : allusers
        this.$nextTick(() => {
          this.$refs.selectionDialog.reset()
          this.busy = false
        })
      },
      async saveUserSelectDialog (selection) {
        this.userSelectDialogVisible = false
        this.busy = true
        await api.postClassLearner(this.$route.params.id, { users: selection.map(selection => selection.id) })
        this.busy = false
        await this.refreshItems()
      },
      cancelUserSelectDialog () {
        this.userSelectDialogVisible = false
      },
      showShortcodeGenerator () {
        this.showGenerator = true
        this.$nextTick(() => this.$refs.generator.retrieveShortcode())
      },
    },
  }
</script>


<style scoped>
  .status {
    padding: 5px 10px;
    border-radius: 5px;
    min-width: 80px;
    text-align: center;
    display: inline-block;
  }
  .quota {
  text-align: center;
  padding-top: 16px;
  }
  .v-chip__content {
    font-size: 12px;
  }
  .big { font-size: 32px !important; }

  .small { padding-left: 20px; font-size: 10px }
  .dropdown-padding { margin-right: -22px}

  .inprogress { background-color: #4bbd4baa !important; }
  .reviewed { background-color: #ccc4c4 !important; }
  .none  { background-color: #ff3f3f !important; }
  .invited { background-color: #ffa40c !important; }
  .activated { background-color: #3dbfb7 !important; }
  .submitted {background-color: #4bbd4b !important; }
  .completed {background-color: #4bbd4b !important; }


  .inprogress-bar .v-progress-linear__determinate { background-color: #4bbd4b !important; }
  .none-bar, .reviewed-bar, .invitied-bar, .submitted-bar  { display: none}
  .status-chip {
    padding: 0px;
    min-width: 150px;
  }

  .status-progress-bar {
    margin: 0;
    border-radius: 16px;
    z-index: 1;
  }

  .status-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  z-index: 2;
}

.v-chip__content {
  width: 100% !important;
}
</style>
